import { Component, OnInit } from '@angular/core';
import { ALL_AIRLINES, ALL_TRAINLINES } from '../util/airlines';
import { FormGroup, FormBuilder, FormArray, Validators, FormControl } from '@angular/forms';
import { Constants } from '../util/constants';
import { FrequentFlyerInfo } from '../entity/frequent-flyer-info';
import { UserAccountService } from '../user-account.service';
import { Subscription } from 'rxjs';
import { ToastrService, ActiveToast } from 'ngx-toastr';
import { UserInfo } from '../entity/user-info';
import { UserAccountInfo } from '../entity/user-account-info';
import { deserialize } from '../util/ta-json/src/methods/deserialize';
import { ALL_HOTELCHAINS } from '../util/hotel-chains';
import { ALL_CARBRANDS } from '../util/car-brands';
import { _ } from '@biesbjerg/ngx-translate-extract/dist/utils/utils';
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'app-profile-loyalty-numbers',
  templateUrl: './profile-loyalty-numbers.component.html',
  styleUrls: ['./profile-loyalty-numbers.component.scss']
})
export class ProfileLoyaltyNumbersComponent implements OnInit {

  all_airlines = [];
  all_trainLines = [];
  trainLineFound=false;
  all_carbrands = [];
  frequentFlyerForm: FormGroup;
  frequentFlyerFormArray: FormArray;
  trainLoyalityForm: FormGroup;
  trainLoyalityFormArray: FormArray;
  duplicateEntryStatus: boolean = false;
  duplicateHotelEntryStatus: boolean = false;
  duplicateCarStatus: boolean = false;
  duplicateTrainEntryStatus = false;
  all_hotelChains = [];
  frequentGuestForm: FormGroup;
  frequentGuestFormArray: FormArray;
  frequentCarLoyalityForm: FormGroup;
  frequentCarLoyalityFormArray: FormArray;
  fetchAccountInfoSubscription: Subscription;
  activeToast: ActiveToast<any>;
  isRequestInProgress: boolean;
  constructor(private fb: FormBuilder,
    private userAccountInfoService: UserAccountService,
    public translateService: TranslateService,
    private toastr: ToastrService,) {
    this.all_airlines = ALL_AIRLINES;
    this.all_trainLines = ALL_TRAINLINES;
    this.all_hotelChains = ALL_HOTELCHAINS;
    this.all_carbrands = ALL_CARBRANDS;
    this.initForms();

  }

  private initForms() {
    this.frequentFlyerFormArray = this.fb.array([]);
    this.frequentFlyerForm = this.fb.group(
      {
        frequentFlyerFormArray: this.frequentFlyerFormArray
      }, { validator: '' });

      this.trainLoyalityFormArray = this.fb.array([]);
      this.trainLoyalityForm = this.fb.group(
        {
          trainLoyalityFormArray: this.trainLoyalityFormArray
        }, { validator: '' });
  
    this.frequentGuestFormArray = this.fb.array([]);
    this.frequentGuestForm = this.fb.group(
      {
        frequentGuestFormArray: this.frequentGuestFormArray
      }, { validator: '' });
    this.
      frequentCarLoyalityFormArray = this.fb.array([]);
    this.frequentCarLoyalityForm = this.fb.group(
      {
        frequentCarLoyalityFormArray: this.frequentCarLoyalityFormArray
      }, { validator: '' });
  }

  ngOnInit() {
    this.fetchAccountInfoSubscription = this.userAccountInfoService.userAccountInfoObjObserver$.subscribe((userAccountInfoObj) => {
      let userAccountInfo = this.userAccountInfoService.getAccountInfo();
      this.initForms();
      if (userAccountInfo && userAccountInfo.userInfo && userAccountInfo.userInfo.ffnMapping) {
        for (let ffnMap of userAccountInfo.userInfo.ffnMapping) {
          if(ffnMap.airline_code!=='9F' && ffnMap.airline_code!=='2V'){
          this.addFrequentFlyerEntry(ffnMap);
          }
        else if(ffnMap.airline_code==='9F' || ffnMap.airline_code==='2V'){
          this.addTrainLineLoyaltyEntry(ffnMap);
        }
      }
      }
      this.addFrequentFlyerEntry(undefined);
      this.addTrainLineLoyaltyEntry(undefined);
      if (userAccountInfo && userAccountInfo.userInfo && userAccountInfo.userInfo.loyalityCards) {
        for (let glnMap of userAccountInfo.userInfo.loyalityCards) {
          this.addFrequentGuestEntry(glnMap);
        }
      }
      this.addFrequentGuestEntry(undefined);
      if (userAccountInfo && userAccountInfo.userInfo && userAccountInfo.userInfo.carLoyaltyNumbers) {
        for (let clnMap of userAccountInfo.userInfo.carLoyaltyNumbers) {
          this.addCarLoyalityEntry(clnMap);
        }
      }
      this.addCarLoyalityEntry(undefined);
    });
  }
  addTrainLineLoyaltyEntry(ffnAirlineMap: FrequentFlyerInfo){
    let newFFNForm = this.fb.group({
      name: [ffnAirlineMap ? ffnAirlineMap.name : '', null],
      airline: [ffnAirlineMap ? ffnAirlineMap.airline_code : '', null],
      flyerNumber: [ffnAirlineMap ? ffnAirlineMap.frequent_flyer_number : '', null],
    });
    this.trainLoyalityFormArray.push(newFFNForm);
    console.log("train loyalty program",this.trainLoyalityFormArray)
    if (ffnAirlineMap && ffnAirlineMap.airline_code && ffnAirlineMap.airline_code.trim() !== ''){
      (<FormGroup>this.trainLoyalityFormArray.controls[this.trainLoyalityFormArray.controls.length - 1]).controls['flyerNumber'].setValidators(
        Validators.compose([Validators.required, Validators.pattern(Constants.RGEX_ALPHANUMERIC)]));
    }
  }
  addFrequentFlyerEntry(ffnAirlineMap: FrequentFlyerInfo) {
    let newFFNForm = this.fb.group({
      name: [ffnAirlineMap ? ffnAirlineMap.name : '', null],
      airline: [ffnAirlineMap ? ffnAirlineMap.airline_code : '', null],
      flyerNumber: [ffnAirlineMap ? ffnAirlineMap.frequent_flyer_number : '', null],
    });
    this.frequentFlyerFormArray.push(newFFNForm);
    if (ffnAirlineMap && ffnAirlineMap.airline_code && ffnAirlineMap.airline_code.trim() !== ''){
      (<FormGroup>this.frequentFlyerFormArray.controls[this.frequentFlyerFormArray.controls.length - 1]).controls['flyerNumber'].setValidators(
        Validators.compose([Validators.required, Validators.pattern(Constants.RGEX_ALPHANUMERIC)]));
    }
  }
  addCarLoyalityEntry(clnMap: any) {
    let newCLNForm = this.fb.group({
      name: [clnMap ? clnMap.rentalCarName : '', null],
      loyalityNumber: [clnMap ? clnMap.rentalCarLoyaltyNumber : '', null],
      carCode: [clnMap ? clnMap.rentalCarCode : '', null]
    });
    this.frequentCarLoyalityFormArray.push(newCLNForm);
    if (clnMap && clnMap.airline_code && clnMap.airline_code.trim() !== '')  {
      (<FormGroup>this.frequentCarLoyalityFormArray.controls[this.frequentCarLoyalityFormArray.controls.length - 1]).controls['loyalityNumber'].setValidators(
        Validators.compose([Validators.required, Validators.pattern(Constants.RGEX_ALPHANUMERIC)]));
    }
  }

  addFrequentGuestEntry(glnHotelChainMap: any) {
    if(glnHotelChainMap && glnHotelChainMap.chain){
    let findndex = this.all_hotelChains.findIndex(item => item.chainCode ===glnHotelChainMap.chain);
    if(findndex===-1 && glnHotelChainMap.chain){
      let tempHotel ={lowerName: glnHotelChainMap.hotel_name,
        key: "Hotel",
        value: glnHotelChainMap.hotel_name,
        chainCode: glnHotelChainMap.chain,
        chainName: glnHotelChainMap.hotel_name
      }
      this.all_hotelChains.push(tempHotel);
    }
  }
    let newGLNForm = this.fb.group({
      name: [glnHotelChainMap ? glnHotelChainMap.hotel_name : '', null],
      hotelChain: [glnHotelChainMap ? glnHotelChainMap.chain : '', null],
      guestNumber: [glnHotelChainMap ? glnHotelChainMap.number : '', null],
    });
    this.frequentGuestFormArray.push(newGLNForm);
    if (glnHotelChainMap && glnHotelChainMap.airline_code && glnHotelChainMap.airline_code.trim() !== ''){
      (<FormGroup>this.frequentGuestFormArray.controls[this.frequentGuestFormArray.controls.length - 1]).controls['guestNumber'].setValidators(
        Validators.compose([Validators.required, Validators.pattern(Constants.RGEX_ALPHANUMERIC)]));
    }
  }

  removeAirline(i: number, val) {
    this.frequentFlyerFormArray.removeAt(i);
    for (var counter = 0; counter < this.frequentFlyerFormArray.controls.length; counter++) {
      if (this.isDuplicateEntry(counter)) {
        this.duplicateEntryStatus = true;
        return;
      }
    }
    this.duplicateEntryStatus = false;
  }

  removeTrainline(i: number, val) {
    this.trainLoyalityFormArray.removeAt(i);
    for (var counter = 0; counter < this.trainLoyalityFormArray.controls.length; counter++) {
      if (this.isDuplicateTarinlineEntry(counter)) {
        this.duplicateTrainEntryStatus = true;
       true;
        return;
      }
    }
    this.duplicateTrainEntryStatus  = false;
  }

  removeHotelChain(i: number) {
    this.frequentGuestFormArray.removeAt(i);
    for (var counter = 0; counter < this.frequentGuestFormArray.controls.length; counter++) {
      if (this.isDuplicateHotelChainEntry(counter)) {
        this.duplicateHotelEntryStatus = true;
        return;
      }
    }
    this.duplicateHotelEntryStatus = false;
  }
  removeCarLoyalityNumber(i: number) {
    this.frequentCarLoyalityFormArray.removeAt(i);
    for (var counter = 0; counter < this.frequentCarLoyalityFormArray.controls.length; counter++) {
      if (this.isDuplicateCarLoyalityEntry(counter)) {
        this.duplicateCarStatus = true;
        return;
      }
    }
    this.duplicateCarStatus = false;
  }
  isEmptyHGNumber(index: number) {
    if ((<FormGroup>this.frequentGuestFormArray.controls[index]).controls.hotelChain.value === '') {
      return false;
    }
    if ((<FormGroup>this.frequentGuestFormArray.controls[index]).controls['guestNumber'].value === '') {
      return true;
    }
    return false;
  }
  isEmptyCLNumber(index: number) {
    if ((<FormGroup>this.frequentCarLoyalityFormArray.controls[index]).controls.carCode.value === '') {
      return false;
    }
    if ((<FormGroup>this.frequentCarLoyalityFormArray.controls[index]).controls['loyalityNumber'].value === '') {
      return true;
    }
    return false;
  }
  isEmptyFFNumber(index: number) {
    if ((<FormGroup>this.frequentFlyerFormArray.controls[index]).controls.airline.value === '') {
      return false;
    }
    if ((<FormGroup>this.frequentFlyerFormArray.controls[index]).controls['flyerNumber'].value === '') {
      return true;
    }
    return false;
  }
  isEmptyTrainlineumber(index: number) {
    if ((<FormGroup>this.trainLoyalityFormArray.controls[index]).controls.airline.value === '') {
      return false;
    }
    if ((<FormGroup>this.trainLoyalityFormArray.controls[index]).controls['flyerNumber'].value === '') {
      return true;
    }
    return false;
  }
  isDuplicateHotelChainEntry(index: number) {
    if (index && this.frequentGuestFormArray
      && this.frequentGuestFormArray.controls
      && (<FormGroup>this.frequentGuestFormArray.controls[index]).controls) {
      if ((<FormGroup>this.frequentGuestFormArray.controls[index]).controls['hotelChain'].value !== '') {
        let val: string = (<FormGroup>this.frequentGuestFormArray.controls[index]).controls['hotelChain'].value;
        for (var counter = 0; counter < this.frequentGuestFormArray.controls.length - 1; counter++) {
          if (counter !== index) {
            if (val === (<FormGroup>this.frequentGuestFormArray.controls[counter]).controls['hotelChain'].value) {
              this.duplicateHotelEntryStatus = true;
              return true;
            }
          }
        }
      }
    }
    return false;
  }
  isDuplicateCarLoyalityEntry(index: number) {
    if (index && this.frequentCarLoyalityFormArray
      && this.frequentCarLoyalityFormArray.controls
      && (<FormGroup>this.frequentCarLoyalityFormArray.controls[index]).controls) {
      if ((<FormGroup>this.frequentCarLoyalityFormArray.controls[index]).controls['carCode'].value !== '') {
        let val: string = (<FormGroup>this.frequentCarLoyalityFormArray.controls[index]).controls['carCode'].value;
        for (var counter = 0; counter < this.frequentCarLoyalityFormArray.controls.length - 1; counter++) {
          if (counter !== index) {
            if (val === (<FormGroup>this.frequentCarLoyalityFormArray.controls[counter]).controls['carCode'].value) {
              this.duplicateCarStatus = true;
              return true;
            }
          }
        }
      }
    }
    return false;
  }
  isDuplicateEntry(index: number) {
    if (index && this.frequentFlyerFormArray
      && this.frequentFlyerFormArray.controls
      && (<FormGroup>this.frequentFlyerFormArray.controls[index]).controls) {
      if ((<FormGroup>this.frequentFlyerFormArray.controls[index]).controls['airline'].value !== '') {
        let val: string = (<FormGroup>this.frequentFlyerFormArray.controls[index]).controls['airline'].value;
        for (var counter = 0; counter < this.frequentFlyerFormArray.controls.length - 1; counter++) {
          if (counter !== index) {
            if (val === (<FormGroup>this.frequentFlyerFormArray.controls[counter]).controls['airline'].value) {
              this.duplicateTrainEntryStatus = true;
              return true;
            }
          }
        }
      }
    }
    return false;
  }
  isDuplicateTarinlineEntry(index: number) {
    if (index && this.trainLoyalityFormArray
      && this.trainLoyalityFormArray.controls
      && (<FormGroup>this.trainLoyalityFormArray.controls[index]).controls) {
      if ((<FormGroup>this.trainLoyalityFormArray.controls[index]).controls['airline'].value !== '') {
        let val: string = (<FormGroup>this.trainLoyalityFormArray.controls[index]).controls['airline'].value;
        for (var counter = 0; counter < this.trainLoyalityFormArray.controls.length - 1; counter++) {
          if (counter !== index) {
            if (val === (<FormGroup>this.trainLoyalityFormArray.controls[counter]).controls['airline'].value) {
              this.duplicateTrainEntryStatus = true;
              return true;
            }
          }
        }
      }
    }
    return false;
  }

  onAirlineChange(i: number) {
    this.duplicateEntryStatus = false;
    if ((<FormGroup>this.frequentFlyerFormArray.controls[i]).controls['airline'].value === '') {
      (<FormGroup>this.frequentFlyerFormArray.controls[i]).controls['flyerNumber'].setValidators(null);
      (<FormGroup>this.frequentFlyerFormArray.controls[i]).controls['flyerNumber'].setErrors(null);
      (<FormGroup>this.frequentFlyerFormArray.controls[i]).controls['flyerNumber'].setValue('');
    } else {
      let airlineCode: string = (<FormGroup>this.frequentFlyerFormArray.controls[i]).controls['airline'].value;
      let selectedObject = ALL_AIRLINES.find(item => item.id == airlineCode);
      (<FormGroup>this.frequentFlyerFormArray.controls[i]).controls['name'].setValue(selectedObject.value);
       (<FormGroup>this.frequentFlyerFormArray.controls[i]).controls['flyerNumber'].setValidators(
        Validators.compose([Validators.required,Validators.pattern(Constants.RGEX_ALPHANUMERIC)]));
      if (i === this.frequentFlyerFormArray.controls.length - 1) {
        this.addFrequentFlyerEntry(undefined);
      }
    }
  }

  onTrainChange(i: number) {
    this.duplicateEntryStatus = false;
    if ((<FormGroup>this.trainLoyalityFormArray.controls[i]).controls['airline'].value === '') {
      (<FormGroup>this.trainLoyalityFormArray.controls[i]).controls['flyerNumber'].setValidators(null);
      (<FormGroup>this.trainLoyalityFormArray.controls[i]).controls['flyerNumber'].setErrors(null);
      (<FormGroup>this.trainLoyalityFormArray.controls[i]).controls['flyerNumber'].setValue('');
    } else {
      let airlineCode: string = (<FormGroup>this.trainLoyalityFormArray.controls[i]).controls['airline'].value;
      let selectedObject = ALL_TRAINLINES.find(item => item.id == airlineCode);
      (<FormGroup>this.trainLoyalityFormArray.controls[i]).controls['name'].setValue(selectedObject.value);
       (<FormGroup>this.trainLoyalityFormArray.controls[i]).controls['flyerNumber'].setValidators(
        Validators.compose([Validators.required,Validators.pattern(Constants.RGEX_ALPHANUMERIC)]));
      if (i === this.trainLoyalityFormArray.controls.length - 1) {
        this.addTrainLineLoyaltyEntry(undefined);
      }
    }
  }

  onHotelChainChange(i: number) {
    this.duplicateHotelEntryStatus = false;
    if ((<FormGroup>this.frequentGuestFormArray.controls[i]).controls['hotelChain'].value === '') {
      (<FormGroup>this.frequentGuestFormArray.controls[i]).controls['guestNumber'].setValidators(null);
      (<FormGroup>this.frequentGuestFormArray.controls[i]).controls['guestNumber'].setErrors(null);
      (<FormGroup>this.frequentGuestFormArray.controls[i]).controls['guestNumber'].setValue('');
    } else {
      let hotelChainCode = (<FormGroup>this.frequentGuestFormArray.controls[i]).controls['hotelChain'].value;
      let selectedHotelObject = ALL_HOTELCHAINS.find(item => item.chainCode == hotelChainCode);
      (<FormGroup>this.frequentGuestFormArray.controls[i]).controls['name'].setValue(selectedHotelObject.value);
      (<FormGroup>this.frequentGuestFormArray.controls[i]).controls['guestNumber'].setValidators(
        Validators.compose([Validators.required, Validators.pattern(Constants.RGEX_ALPHANUMERIC)]));
      if (i === this.frequentGuestFormArray.controls.length - 1) {
        this.addFrequentGuestEntry(undefined);
      }
    }
  }

  private getUpdatedFrequentFlyerData(): UserInfo {
    let p = this.frequentFlyerForm.value;
    let p1 = this.trainLoyalityForm.value;
    let userInfoDTO = this.userAccountInfoService.getAccountInfo().userInfo;
    // p.frequentFlyerFormArray.splice(-1,1);
    let ffnMapping = Array<FrequentFlyerInfo>();
    for (let formFfn of p.frequentFlyerFormArray) {
      if (formFfn.airline === '' || !formFfn.airline) continue;
      let ffnMap = new FrequentFlyerInfo();
      ffnMap.name = formFfn.name;
      ffnMap.airline_code = formFfn.airline;
      ffnMap.frequent_flyer_number = formFfn.flyerNumber;
      ffnMapping.push(ffnMap);
    }
    for (let formFfn of p1.trainLoyalityFormArray) {
      if (formFfn.airline === '' || !formFfn.airline) continue;
      let ffnMap = new FrequentFlyerInfo();
      ffnMap.name = formFfn.name;
      ffnMap.airline_code = formFfn.airline;
      ffnMap.frequent_flyer_number = formFfn.flyerNumber;
      ffnMapping.push(ffnMap);
    }
    userInfoDTO.ffnMapping = ffnMapping;

    return userInfoDTO;
  }
 

  private getUpdatedFrequentGuestData(): UserInfo {
    let p = this.frequentGuestForm.value;
    let userInfoDTO = this.userAccountInfoService.getAccountInfo().userInfo;
    // p.frequentGuestFormArray.splice(-1,1);
    let glnMapping = Array<any>();
    for (let formGln of p.frequentGuestFormArray) {
      if (formGln.hotelChain === '' || !formGln.hotelChain) continue;
      let glnMap: any = {};
      glnMap.hotel_name = formGln.name;
      glnMap.chain = formGln.hotelChain;
      glnMap.number = formGln.guestNumber;
      glnMapping.push(glnMap);
    }
    userInfoDTO.loyalityCards = glnMapping;

    return userInfoDTO;
  }

  saveFrequentFlyerNumbers() {
    this.validateAllFormFields(this.frequentFlyerForm);
    for (var counter = 0; counter < this.frequentFlyerFormArray.length; counter++) {
      if (this.isEmptyFFNumber(counter)) {
        return;
      }
    }

    if (!this.duplicateEntryStatus && this.frequentFlyerForm.valid) {
      this.saveAndUpdateProfileInfo(this.getUpdatedFrequentFlyerData(), 'savePersonalInfoBtn');
    }
  }
  saveTrainLineNumbers() {
    this.validateAllFormFields(this.trainLoyalityForm);
    for (var counter = 0; counter < this.trainLoyalityFormArray.length; counter++) {
      if (this.isEmptyTrainlineumber(counter)) {
        return;
      }
    }

    if (!this.duplicateTrainEntryStatus && this.trainLoyalityForm.valid) {
      this.saveAndUpdateProfileInfo(this.getUpdatedFrequentFlyerData(), 'savePersonalInfoBtn');
    }
  }

  saveFrequentCarLoyalityNumbers() {
    this.validateAllFormFields(this.frequentCarLoyalityForm);

    for (var counter = 0; counter < this.frequentCarLoyalityFormArray.length; counter++) {
      if (this.isEmptyCLNumber(counter)) {
        return;
      }
    }
    if (!this.duplicateHotelEntryStatus && this.frequentCarLoyalityForm.valid) {
      this.saveAndUpdateProfileInfo(this.getUpdatedFrequenCarLoyalityData(), 'savePersonalInfoBtn');
    }
  }
  private getUpdatedFrequenCarLoyalityData(): UserInfo {
    let p = this.frequentCarLoyalityForm.value;
    let userInfoDTO = this.userAccountInfoService.getAccountInfo().userInfo;
    // p.frequentGuestFormArray.splice(-1,1);
    let clnMapping = Array<any>();
    for (let formCln of p.frequentCarLoyalityFormArray) {
      if (formCln.carCode === '' || !formCln.carCode) continue;
      let clnMap: any = {};
      clnMap.rentalCarName = formCln.name;
      clnMap.rentalCarCode = formCln.carCode;
      clnMap.rentalCarLoyaltyNumber = formCln.loyalityNumber;
      clnMapping.push(clnMap);
    }
    userInfoDTO.carLoyaltyNumbers = clnMapping;

    return userInfoDTO;
  }
  saveFrequentGuestNumbers() {
    this.validateAllFormFields(this.frequentGuestForm);

    for (var counter = 0; counter < this.frequentGuestFormArray.length; counter++) {
      if (this.isEmptyHGNumber(counter)) {
        return;
      }
    }
    if (!this.duplicateHotelEntryStatus && this.frequentGuestForm.valid) {
      this.saveAndUpdateProfileInfo(this.getUpdatedFrequentGuestData(), 'savePersonalInfoBtn');
    }
  }
  validateAllFormFields(formGroup: FormGroup) {         //{1}
    Object.keys(formGroup.controls).forEach(field => {  //{2}
      const control = formGroup.get(field);             //{3}
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        //{5}
        this.validateAllFormFields(control);            //{6}
      }
    });
  }


  private saveAndUpdateProfileInfo(userInfoDTO: UserInfo, saveButtonId: string) {
    this.isRequestInProgress = true;
    this.showProgress();
    this.fetchAccountInfoSubscription = this.userAccountInfoService.saveAccountInfo(
      userInfoDTO).subscribe(res => {
        this.isRequestInProgress = false;
        if (res.success == true) {
          this.showSuccess();
          //   this.isChangePasswordMode = false;
          if (res.data) {
            let userAccountInfoObj: UserAccountInfo = deserialize(res.data, UserAccountInfo);
            this.userAccountInfoService.setAccountInfo(userAccountInfoObj);
          }
        } else {
          this.showError();
        }
      }, error => {
        this.showError();
      });
  }

  showSuccess() {
    this.toastr.remove(this.activeToast.toastId);
    this.activeToast = this.toastr.success(this.translateService.instant('profilePage.Profilesavedsuccessfully').toString());
  }

  showProgress() {
    if (this.activeToast) {
      this.toastr.remove(this.activeToast.toastId);
    }
    this.activeToast = this.toastr.info(this.translateService.instant('profilePage.Pleasewait').toString(), this.translateService.instant('profilePage.Saving').toString());
  }

  showError() {
    if (this.activeToast) {
      this.toastr.remove(this.activeToast.toastId);
    }
    this.activeToast = this.toastr.success('Error!', 'Unknown error while saving profile');
  }

  ffnShortInFO(array) {
    let templateArray = [];
    let template = "";
    // for(let name of array.value){
    //     if(name.name !="" && name.flyerNumber != ""){
    //         templateArray.push(`${name.name} | ${name.flyerNumber}`);
    //     }
    // }
    // template = templateArray.join(' , ');
    // return template;
    for (let counter: number = 0; counter < this.frequentFlyerFormArray.controls.length; counter++) {
      let currObj: any = (<FormGroup>this.frequentFlyerFormArray.controls[counter]).controls;
      if (currObj['name'].value !== '' && currObj['flyerNumber'].value !== '') {
        templateArray.push(`${currObj['name'].value} | ${currObj['flyerNumber'].value}`);
      }
    }
    template = templateArray.join(' , ');
    return template;
  }

  trainShortInFO(array) {
    let templateArray = [];
    let template = "";
    // for(let name of array.value){
    //     if(name.name !="" && name.flyerNumber != ""){
    //         templateArray.push(`${name.name} | ${name.flyerNumber}`);
    //     }
    // }
    // template = templateArray.join(' , ');
    // return template;
    for (let counter: number = 0; counter < this.trainLoyalityFormArray.controls.length; counter++) {
      let currObj: any = (<FormGroup>this.trainLoyalityFormArray.controls[counter]).controls;
      if (currObj['name'].value !== '' && currObj['flyerNumber'].value !== '') {
        templateArray.push(`${currObj['name'].value} | ${currObj['flyerNumber'].value}`);
      }
    }
    template = templateArray.join(' , ');
    return template;
  }

  fgnShortInFO(array) {
    let templateArray = [];
    let template = "";
    for (let name of array.value) {
      if (name.name != "" && name.guestNumber != "") {
        templateArray.push(`${name.name} | ${name.guestNumber}`);
      }
    }
    template = templateArray.join(' , ');
    return template;
  }
  clnShortInfo(array) {
    let templateArray = [];
    let template = "";
    for (let name of array.value) {
      if (name.name != "" && name.loyalityNumber != "") {
        templateArray.push(`${name.name} | ${name.loyalityNumber}`);
      }
    }
    template = templateArray.join(' , ');
    return template;
  }
  onCarLoyalityNumberchange(i) {
    this.duplicateCarStatus = false;
    if ((<FormGroup>this.frequentCarLoyalityFormArray.controls[i]).controls['carCode'].value === '') {
      (<FormGroup>this.frequentCarLoyalityFormArray.controls[i]).controls['loyalityNumber'].setValidators(null);
      (<FormGroup>this.frequentCarLoyalityFormArray.controls[i]).controls['loyalityNumber'].setErrors(null);
      (<FormGroup>this.frequentCarLoyalityFormArray.controls[i]).controls['loyalityNumber'].setValue('');
    } else {
      let carBrandCode = (<FormGroup>this.frequentCarLoyalityFormArray.controls[i]).controls['carCode'].value;
      let selectedCarObject = ALL_CARBRANDS.find(item => item.carcode == carBrandCode);
      (<FormGroup>this.frequentCarLoyalityFormArray.controls[i]).controls['name'].setValue(selectedCarObject.value);
      (<FormGroup>this.frequentCarLoyalityFormArray.controls[i]).controls['loyalityNumber'].setValidators(
        Validators.compose([Validators.required, Validators.pattern(Constants.RGEX_ALPHANUMERIC)]));
      if (i === this.frequentCarLoyalityFormArray.controls.length - 1) {
        this.addCarLoyalityEntry(undefined);
      }
    }
  }


}
